exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-scrollbar{overflow:hidden;position:relative}", ""]);

// exports
